import { render } from "./HomeAbout.vue?vue&type=template&id=5e4f0a78&scoped=true&lang=html"
import script from "./HomeAbout.vue?vue&type=script&lang=js"
export * from "./HomeAbout.vue?vue&type=script&lang=js"

import "./HomeAbout.vue?vue&type=style&index=0&id=5e4f0a78&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4f0a78"]])

export default __exports__